module.exports = __webpack_public_path__ + "img/investments.b6b68c26.png";